export default "__VITE_ASSET__Cjj$w1LA__";